import * as actionType from "../constants";

export const toggleMenu = () => (dispatch) => {
  dispatch({ type: actionType.TOGGLE_MENU });
};
